module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNNS4wODMwMSAwLjYwNTQ2OUwyLjk5OTY3IDIuNjg4OEwwLjkxNjM0MSA0Ljc3MjE0IiBzdHJva2U9IiMxRDFEMUQiIHN0cm9rZS13aWR0aD0iMC45ODAzOTIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMC45MTY1MDQgMC42MDU0NjlMMi45OTk4NCAyLjY4ODhMNS4wODMxNyA0Ljc3MjE0IiBzdHJva2U9IiMxRDFEMUQiIHN0cm9rZS13aWR0aD0iMC45ODAzOTIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./static/images/icon/orderX.svg
// module id = 1rDv
// module chunks = 1